import { createContext, useContext, useState } from "react";

const dias = (n) => new Date(Date.now() + n * 86400000).toISOString();

const SEED = [
  { id: "tk-1", titulo: "Llamar al propietario por el ajuste de Arcos 343", agenteId: "ag-1", vence: dias(1), prioridad: "Alta", hecha: false },
  { id: "tk-2", titulo: "Subir los avisos nuevos de Palermo al portal", agenteId: "ag-2", vence: dias(2), prioridad: "Media", hecha: false },
  { id: "tk-3", titulo: "Enviar las liquidaciones del mes a propietarios", agenteId: "ag-1", vence: dias(3), prioridad: "Media", hecha: false },
  { id: "tk-4", titulo: "Coordinar la visita en Cuba 1144", agenteId: "ag-3", vence: dias(0), prioridad: "Alta", hecha: false },
  { id: "tk-5", titulo: "Relevar el estado de la unidad en Serrano 1520", agenteId: "ag-3", vence: dias(4), prioridad: "Baja", hecha: false },
  { id: "tk-6", titulo: "Renovar el seguro de caución de 2 contratos", agenteId: "ag-2", vence: dias(5), prioridad: "Media", hecha: true },
];

const TasksContext = createContext(null);

export function TasksProvider({ children }) {
  const [tareas, setTareas] = useState(SEED);
  const addTarea = (t) => setTareas((prev) => [{ id: "tk-" + Date.now(), hecha: false, ...t }, ...prev]);
  const toggleTarea = (id) => setTareas((prev) => prev.map((t) => (t.id === id ? { ...t, hecha: !t.hecha } : t)));
  return <TasksContext.Provider value={{ tareas, addTarea, toggleTarea }}>{children}</TasksContext.Provider>;
}

export function useTasks() {
  const ctx = useContext(TasksContext);
  if (!ctx) throw new Error("useTasks debe usarse dentro de TasksProvider");
  return ctx;
}
